import React from 'react'

const ComboDato = ({ name, textoDefault, arr, value, text, handler, Ref }) => {
  return (
    <select
    ref={Ref}
    onChange={(e) => handler(e)}
    name={name}
    type="select"
    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
  >
    <option value="">{textoDefault}</option>
    {arr.length > 0 && arr.map((item) => (
      <option key={item[value]} value={item[value]}>
        {item[text]}
      </option>
    ))}
  </select>
  )
}

export default ComboDato